import { productTypeServiceModule } from '../../../../shared/app/services/product-type-service/product-type-service';
import { billingPlansServiceModule } from '../../../../shared/app/services/billing-plans-service/billing-plans-service';
import { billingPlansTableComponentModule } from '../../../../shared/app/components/billing-plans-table/billing-plans-table';
import { billingFeaturesServiceModule } from '../../../../shared/app/services/billing-features-service/billing-features-service';
import subscriptionsTemplate from './subscriptions.tpl.html';

export const subscriptionsComponentModule = angular
  .module('Q.components.subscriptions', [
    productTypeServiceModule,
    billingPlansTableComponentModule,
    billingFeaturesServiceModule,
    billingPlansServiceModule,
  ])

  .directive(
    'subscriptions',
    function (
      billingPlansService,
      billingFeaturesService,
      productTypeService,
      $timeout,
      $location,
      $document,
    ) {
      const educationReferrers = /education/;

      return {
        restrict: 'E',
        scope: {
          onSelect: '&',
          discount: '=',
        },
        template: subscriptionsTemplate,
        link(scope) {
          scope.plans = [];
          scope.productType = 'recruitment';
          if (
            $location.search().education ||
            educationReferrers.test($document[0].referrer)
          ) {
            scope.productType = 'education';
          }

          scope.switchProductType = () => {
            productTypeService.setProduct(scope.productType);
            billingFeaturesService.load().then(() => {
              billingPlansService.load().then((plans) => {
                scope.plans = plans;
              });
            });
          };
          scope.switchProductType();

          scope.select = (plan, eventName) => {
            scope.onSelect({ plan, eventName });
          };
        },
      };
    },
  );
